module.exports = __webpack_public_path__ + "static/canonical-4850525dd7fd2cfa1f521835c7bb6b5b.png";